
import '../../../Osc.Common/Frontend/styles/views.login.scss';
import '../../../Osc.Common/Frontend/styles/main.scss';
import '../styles/trumps.scss';